var _defs, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAxisLogoLoader(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "eI0eVwK9tdo1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 48 48",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    "project-id": "09ee77c4ec3d47be8d1f44ae580292ce",
    "export-id": "19713d84bb6d4a999d6b5ca0a89e29cf",
    cached: "false",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "eI0eVwK9tdo5-fill",
    cx: 0,
    cy: 0,
    r: 1.002199,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(0 21 -21 0 0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eI0eVwK9tdo5-fill-0",
    offset: "24%",
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eI0eVwK9tdo5-fill-1",
    offset: "100%",
    stopColor: "rgba(255,255,255,0)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eI0eVwK9tdo9-stroke",
    x1: 0.003549,
    y1: 0.000741,
    x2: 0.992908,
    y2: 0.994042,
    spreadMethod: "pad",
    gradientUnits: "objectBoundingBox",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eI0eVwK9tdo9-stroke-0",
    offset: "0%",
    stopColor: "rgba(242,61,114,0)"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eI0eVwK9tdo9-stroke-1",
    offset: "19%",
    stopColor: "#f23d72"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eI0eVwK9tdo9-stroke-2",
    offset: "50%",
    stopColor: "#f23d72"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eI0eVwK9tdo9-stroke-3",
    offset: "83%",
    stopColor: "#f23d72"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eI0eVwK9tdo9-stroke-4",
    offset: "100%",
    stopColor: "rgba(242,61,114,0)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eI0eVwK9tdo11-stroke",
    x1: 0.007944,
    y1: 0.005859,
    x2: 0.988106,
    y2: 0.988546,
    spreadMethod: "pad",
    gradientUnits: "objectBoundingBox",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eI0eVwK9tdo11-stroke-0",
    offset: "0%",
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eI0eVwK9tdo11-stroke-1",
    offset: "12.5244%",
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eI0eVwK9tdo11-stroke-2",
    offset: "48%",
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eI0eVwK9tdo11-stroke-3",
    offset: "87.665%",
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eI0eVwK9tdo11-stroke-4",
    offset: "100%",
    stopColor: "#000"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.999999-.001587 0.001587 0.999999-.846963-.579718)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "eI0eVwK9tdo3",
    rx: 4.5,
    ry: 27.5,
    transform: "matrix(-.707107-.707107 0.707107-.707107 24 24)",
    fill: "none",
    stroke: "#f23d72",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeDashoffset: 1,
    strokeDasharray: "0,120"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#eI0eVwK9tdo6)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 21,
    transform: "matrix(.461407 0 0 0.46141 20.673664 20.465807)",
    fill: "url(#eI0eVwK9tdo5-fill)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "eI0eVwK9tdo6",
    "mask-type": "luminance",
    x: "-150%",
    y: "-150%",
    height: "400%",
    width: "400%"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 9.207465,
    height: 23.13876,
    rx: 0,
    ry: 0,
    transform: "matrix(.734755 0.678332-1.222602 1.324297 30.953487 1.590174)",
    fill: "#fff",
    strokeWidth: 0
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#eI0eVwK9tdo10)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "eI0eVwK9tdo9",
    d: "M0,0L43.641141,43.641091",
    transform: "matrix(.870738 0 0 0.870739-34.734828-34.734828)",
    fill: "none",
    stroke: "url(#eI0eVwK9tdo9-stroke)",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("mask", {
    id: "eI0eVwK9tdo10",
    "mask-type": "luminance",
    x: "-150%",
    y: "-150%",
    height: "400%",
    width: "400%"
  }, /*#__PURE__*/React.createElement("path", {
    id: "eI0eVwK9tdo11",
    d: "M0,0L40.195788,40.195742",
    transform: "matrix(.9 0 0 0.9 1.188897 1.188897)",
    fill: "none",
    stroke: "url(#eI0eVwK9tdo11-stroke)",
    strokeWidth: 4
  })))), /*#__PURE__*/React.createElement("rect", {
    style: {
      mixBlendMode: "multiply"
    },
    width: 48,
    height: 24,
    rx: 0,
    ry: 0,
    transform: "translate(0 24)",
    opacity: 0.8,
    fill: "url(#eI0eVwK9tdo12-fill)",
    strokeWidth: 0
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAxisLogoLoader);
export default __webpack_public_path__ + "static/media/axis_logo_loader.0df08798f4a51f84f85a7ab6754c6df3.svg";
export { ForwardRef as ReactComponent };